import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyPage"] */ "/www/wwwroot/gass/fe-new/components/legal/privacy-policy-page.tsx");
